<template>
  <div class="page" :class="pageSizeClass">
    <!-- 상단 영역: 제목 + Vol 정보 -->
    <div class="header-section">
      <!-- 저널 제목 (좌측) -->
      <div class="journal-title-section">
        <p class="journal-title-line1">International</p>
        <p class="journal-title-line1">Journal of</p>
        <p class="journal-title-line2">Korean Applied</p>
        <p class="journal-title-line2">Linguistics</p>
      </div>

      <!-- Vol. 및 날짜 정보 (우측 상단) -->
      <div class="vol-section">
        <div class="vol-line"></div>
        <p class="vol-text">{{ displayVolume }}</p>
        <p class="date-text">December</p>
        <p class="year-text">{{ displayYearSpaced }}</p>
      </div>
    </div>

    <!-- ISSN 정보 -->
    <div class="issn-section">
      <p class="issn-text">ISSN: 2799-9106</p>
    </div>

    <!-- 커버 이미지 -->
    <div class="cover-image-section">
      <img
        class="cover-image"
        src="@/assets/cover/270_in.png"
        alt="Cover Image"
      />
    </div>

    <!-- 학회 정보 (하단) -->
    <div class="society-info-section">
      <img
        class="society-logo"
        src="@/assets/cover/iskal_logo_in.png"
        alt="ISKAL Logo"
      />
      <div class="society-text">
        <p class="society-name-en">
          The International Society of Korean Applied Linguistics
        </p>
        <p class="society-name-ko">국제한국어응용언어학회</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "article-inner-cover-front",
  props: {
    group: {
      type: Object,
      required: false,
      default: () => {},
    },
    journal: {
      type: Object,
      required: false,
      default: () => {},
    },
    pageSize: {
      type: String,
      required: false,
      default: "A5",
    },
  },
  computed: {
    pageSizeClass() {
      return this.pageSize?.toLowerCase() || "a5";
    },
    displayVolume() {
      return `Vol. ${this.journal?.volume || ""}`;
    },
    displayMonth() {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const monthIndex = this.journal?.month
        ? parseInt(this.journal.month) - 1
        : new Date().getMonth();
      return months[monthIndex] || "";
    },
    displayYear() {
      return this.journal?.year || new Date().getFullYear();
    },
    displayYearSpaced() {
      const year = this.journal?.year || new Date().getFullYear();
      return String(year).split("").join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
$primary-font-color: #231815;
$secondary-font-color: #666666;
$background-color: #ffffff;

// A4 패딩
$a4-vertical-padding: 50px;
$a4-horizontal-padding: 60px;

// A5 패딩
$a5-vertical-padding: 35px;
$a5-horizontal-padding: 40px;

$sans-font-family: "Sandoll GtNeoCond", "Noto Sans KR", sans-serif;
$batang-font-family: "KoPubWorldBatang", "Noto Sans KR", sans-serif;

$a4-width: 794px;
$a4-height: 1122px;
$a5-width: 559px;
$a5-height: 794px;

/** ****************************************************************************************
 * [ 페이지 공통 스타일 ]
 *******************************************************************************************/
.page {
  background-color: $background-color;
  position: relative;
  box-sizing: border-box;
  height: auto;
  overflow: hidden;
  page-break-before: always;
  page-break-after: always;

  &.a4 {
    width: $a4-width;
    min-height: $a4-height;
    padding: $a4-vertical-padding $a4-horizontal-padding;

    .header-section {
      margin-bottom: 20px;
    }

    .journal-title-section {
      margin-top: 20px;
    }

    .journal-title-line1,
    .journal-title-line2 {
      font-size: 42px;
    }

    .vol-section {
      margin-top: 20px;
    }

    .vol-text {
      font-size: 22px;
    }

    .date-text,
    .year-text {
      font-size: 10px;
    }

    .issn-text {
      font-size: 12px;
    }

    .cover-image-section {
      margin-right: -$a4-horizontal-padding;
      height: 550px;
      width: calc(100% + #{$a4-horizontal-padding});
    }

    .cover-image {
      max-height: 550px;
    }

    .society-info-section {
      bottom: $a4-vertical-padding;
      left: $a4-horizontal-padding;
      gap: 15px;
    }

    .society-logo {
      max-height: 100px;
    }

    .society-name-en {
      font-size: 12px;
    }

    .society-name-ko {
      font-size: 15px;
    }
  }

  &.a5 {
    width: $a5-width;
    min-height: $a5-height;
    padding: $a5-vertical-padding $a5-horizontal-padding;

    .header-section {
      margin-bottom: 12px;
    }

    .journal-title-line1,
    .journal-title-line2 {
      font-size: 31px;
      line-height: 1.1;
    }

    .vol-section {
      margin-top: 6px;
    }

    .vol-line {
      border-top-width: 2px;
      margin-bottom: 4px;
    }

    .vol-text {
      font-size: 15px;
      letter-spacing: 1px;
    }

    .date-text,
    .year-text {
      font-size: 8px;
      letter-spacing: 3px;
    }

    .issn-section {
      margin-bottom: 6px;
    }

    .issn-text {
      font-size: 9px;
    }

    .cover-image-section {
      margin: 22px 0 0 0;
      height: 350px;
      width: calc(100% + #{$a5-horizontal-padding});
      margin-right: -$a5-horizontal-padding;
    }

    .cover-image {
      max-height: 350px;
    }

   .society-info-section {
      bottom: 40px;
      left: $a5-horizontal-padding;
      gap: 10px;
    }


    .society-logo {
      max-height: 80px;
    }

    .society-name-en {
      font-size: 10px;
      line-height: 1.6;
    }

    .society-name-ko {
      font-size: 12px;
      line-height: 1.6;
    }
  }
}

/** ****************************************************************************************
 * [ 상단 헤더 섹션 ]
 *******************************************************************************************/
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/** ****************************************************************************************
 * [ 저널 제목 섹션 ]
 *******************************************************************************************/
.journal-title-section {
  flex-shrink: 1;
  min-width: 0;
}

.journal-title-line1 {
  font-family: $sans-font-family;
  font-style: normal;
  font-weight: 400;
  color: $secondary-font-color;
  text-align: left;
  margin: 0;
  line-height: 1.15;
}

.journal-title-line2 {
  font-family: $sans-font-family;
  font-weight: 700;
  font-style: normal;
  color: $primary-font-color;
  text-align: left;
  margin: 0;
  line-height: 1.15;
}

/** ****************************************************************************************
 * [ Vol. 및 날짜 섹션 (우측 상단) ]
 *******************************************************************************************/
.vol-section {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
}

.vol-line {
  border-bottom: 3px solid $secondary-font-color;
  margin-bottom: 8px;
  width: 100%;
}

.vol-text {
  font-family: $sans-font-family;
  font-weight: 700;
  letter-spacing: 1px;
  color: $secondary-font-color;
  text-align: center;
  margin: 0;
  width: 100%;
}

.date-text {
  font-family: $sans-font-family;
  font-weight: 400;
  color: $secondary-font-color;
  text-align: center;
  letter-spacing: 1px!important;
  margin: 0;
  width: 100%;
}

.year-text {
  font-family: $sans-font-family;
  font-weight: 400;
  color: $secondary-font-color;
  text-align: center;
  margin: 0;
  letter-spacing: 5px;
  white-space: nowrap;
  width: 100%;
}

/** ****************************************************************************************
 * [ ISSN 섹션 ]
 *******************************************************************************************/
.issn-section {
  text-align: right;
  margin-bottom: 10px;
}

.issn-text {
  font-family: $sans-font-family;
  font-weight: 400;
  color: $secondary-font-color;
  text-align: right;
  margin: 0;
}

/** ****************************************************************************************
 * [ 커버 이미지 섹션 ]
 *******************************************************************************************/
.cover-image-section {
  position: relative;
  margin: 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.cover-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: cover;
}

/** ****************************************************************************************
 * [ 학회 정보 섹션 (하단) ]
 *******************************************************************************************/
.society-info-section {
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.society-logo {
  width: auto;
  height: auto;
}

.society-text {
  display: flex;
  flex-direction: column;
}

.society-name-en {
  font-family: $sans-font-family;
  font-weight: 400;
  color: $primary-font-color;
  text-align: left;
  margin: 0;
}

.society-name-ko {
  font-family: $sans-font-family;
  font-weight: 500;
  color: $primary-font-color;
  text-align: left;
  margin: 0;
}
</style>
